import React, {useEffect, useState} from 'react'
import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Alert,
  Paper,
  TextField
} from '@mui/material'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import DateForm from "@components/DateForm";
import {useDispatch, useSelector} from "react-redux";
import {
  saveAbsentee,
  deleteAbsentee
} from '@store/absentee'

const StyledDialogContent = styled(DialogContent)({
  backgroundColor: '#fdfdfd',
  borderTop: '1px solid #eee',
  borderBottom: '1px solid #eee',
  padding: 0
})
const initData = {
  phone: '',
  expireDate: null,
}

const AbsenteeModal = ({
                     open,
                     completeModal
                   }) => {
  const theme = useTheme()
  const disaptch = useDispatch()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [ form, setForm ] = useState(initData)
  const {
    absenteeInfo,
    isLoading
  } = useSelector(store => store.absentee)

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return
    }
    completeModal()
  }

  const handleChangeData = (key, value) => {
    const updateForm = {}
    updateForm[key] = value
    setForm(Object.assign({}, form, updateForm))
  }

  const handleSave = () => {
    disaptch(saveAbsentee(form))
    completeModal()
  }

  const handleDelete = () => {
    disaptch(deleteAbsentee())
    completeModal()
  }

  useEffect(() => {
    setForm(absenteeInfo || initData)
  }, [absenteeInfo])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="부재자 설정"
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle id="responsive-dialog-title">
        부재자 대리인 등록
      </DialogTitle>

      <StyledDialogContent>
        <Alert severity="warning" icon={false} sx={{pl: 3, mb: 1}}>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 본 담당자가 부재시 로그인 인증알림톡을 대신 받을 대리인을 등록해주시기 바랍니다.
          </Typography>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 대리인 등록 이후엔 담당자, 대리인 모두에게 로그인 인증알림톡이 발송됩니다.
          </Typography>
          <Typography variant="subtitle2" gutterBottom component="p">
            - 최대 14일까지 등록 가능합니다.
          </Typography>
        </Alert>
        <Paper elevation={0} sx={{p: 3, mb: -3}}>
          <Typography variant="subtitle2" gutterBottom component="p">
            * 대리인의 핸드폰번호를 입력해주세요.
          </Typography>
          <TextField
            value={form.phone}
            fullWidth
            placeholder="ex) 01012345678"
            onChange={e => handleChangeData("phone", e.target.value)}
            required={true}
            disabled={absenteeInfo != null}
          />
        </Paper>
        <Paper elevation={0} sx={{p: 3}}>
          <Typography variant="subtitle2" gutterBottom component="p">
            * 부재기간을 설정해주세요.
          </Typography>
          <DateForm
            dataKey={"expireDate"}
            displayName={{expireDate: "부재기간"}}
            form={form}
            handleChangeData={handleChangeData}
            required={true}
            disabled={absenteeInfo != null}
          />
        </Paper>
      </StyledDialogContent>

      <DialogActions>
        {
          absenteeInfo ? <Button variant="contained" onClick={handleDelete} disabled={isLoading}>
              등록취소
            </Button> :
            <Button variant="contained" onClick={handleSave} disabled={isLoading}>
              등록
            </Button>
        }
        <Button onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AbsenteeModal